import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleModal, toggleSecondModalClose } from '../../storage/actions/modalsActions';
import AddOrEditTeamsReduxForm from '../layout/reduxForm/AddOrEditTeamReduxFrom';
import getClients from '../../utils/api/get/getClients';
import getTeam from '../../utils/api/get/getTeam';
import addOrEditTeam from '../../utils/reduxForm/onSubmit/addOrEditTeam';
import emptyValues from '../../utils/reduxForm/InitialValues/addTeam';
import DashboardModalLoader from '../dashboard/common/DashboardModalLoader';

const AddOrEditTeams = ({ modalState, toggleModal, toggleSecondModalClose }) => {
  const typeData = modalState.type && typeof modalState.type === 'object'
    ? modalState.type
    : {};
  const { id } = typeData;

  const [clients, setClients] = useState([]);
  const [teamUsers, setTeamUsers] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      const clientsData = await getClients();
      setClients(clientsData || []);

      if (id) {
        const teamData = await getTeam(id);
        if (teamData) {
          setTeamUsers({
            _id: teamData._id,
            name: teamData.name,
            members: teamData.teamUsers?.map(user => user.userId) || [],
          });
        } else {
          setTeamUsers(emptyValues);
        }
      }

      setIsLoading(false);
    };

    fetchData();
  }, [id]);

  const closeModal = () => {
    toggleModal(false, 'addOrEditTeams');
  };

  if (!modalState.isOpen) {
    return null;
  }

  return (
    <div className="popup_block dashboard-modal showed">
      <div className="popup_container">
        {isLoading && <DashboardModalLoader />}
        <div className="popup_head">
          <div className="popup_title">{id ? 'Edit team' : 'Add team'}</div>
          <button type="button" className="close_btn" aria-label="close" onClick={closeModal}>
            ×
          </button>
        </div>
        {!isLoading && (
          <AddOrEditTeamsReduxForm
            users={clients}
            initialValues={id && teamUsers ? teamUsers : emptyValues}
            closeModal={closeModal}
            onSubmit={addOrEditTeam}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.addOrEditTeams,
});

export default connect(mapStateToProps, { toggleModal, toggleSecondModalClose })(AddOrEditTeams);
